<div class="password-requirements">
  <h3 class="password-requirements__title">Requirements and Recommendations</h3>

  <ul class="password-requirements__validation-list">
    <li class="password-requirements__validation" *ngFor="let recommendation of passwordRecommendations">
      {{ recommendation }}
    </li>
  </ul>
</div>
